import { gql } from '@apollo/client/core'

export const designerKudosFragment = gql`
  fragment DesignerKudosListProps on KudosList {
    count
    kudos {
      givenBy {
        id
        firstName
        lastName
        nickname
      }
      thingType
      ... on HasThing {
        thing {
          id
          thingType
          imageUrl
          colors {
            hex
          }
        }
      }
    }
  }
`

export const myKudosFragment = gql`
  fragment MyKudosProps on Kudos {
    givenBy {
      id
      firstName
      lastName
      imageUrl
      hometown
      sign
      nickname
    }
  }
`
export const allKudosFragment = gql`
  ${myKudosFragment}
  fragment KudosListProps on KudosList {
    count
    kudos {
      ...MyKudosProps
    }
  }
`

export const thingPropsFragment = gql`
  ${allKudosFragment}
  ${myKudosFragment}
  fragment KudosThingProps on Thing {
    id
    allKudos {
      ...KudosListProps
    }
    myKudos {
      ...MyKudosProps
    }
  }
`

export const kudosOutputFragment = gql`
  ${myKudosFragment}
  ${thingPropsFragment}
  fragment KudosOutput on Kudos {
    ...MyKudosProps

    ... on ImageKudos {
      thing {
        ...KudosThingProps
      }
    }
    ... on MockupKudos {
      thing {
        ...KudosThingProps
      }
    }
    ... on PaletteKudos {
      thing {
        ...KudosThingProps
      }
    }
    ... on ProductKudos {
      thing {
        ...KudosThingProps
      }
    }
  }
`
